'use strict';

var Log = require('utils/log');
var Sidemenu = require('utils/theme/sidemenu');
var Resizing = require('utils/theme/resizing');

// Ubold Admin Template

// -> Combines the relevant code from the Theme files 'jquery.core.js'
//    and 'jquery.app.js'. Provides methods to trigger UI element
//    initialization from views (e.g. in onAttach).

var Theme = {};

Theme.InitializeSidemenuToggle = function () {
    Log.info('Theme::InitializeSidemenuToggle');
    Sidemenu.initToggle();
};

Theme.InitializeSidemenu = function () {
    Log.info('Theme::InitializeSidemenu');
    Sidemenu.init();
};

Theme.Init = function () {
    Resizing.init();
    $('body').trigger('resize');

    // disable Firefox's default drag'n'drop to prevent unwanted interaction with user actions
    $(document).on('dragstart', function () {
        return false;
    });
};

module.exports = Theme;
